<template>
    <v-content>
        <slot></slot>
    </v-content>
</template>

<script>
export default {
  name: 'AuthLayout'
}
</script>